import { LogPointStates } from '../../util/LogPointsService'
import { AppState, Dispatch } from '../../../../types'
import { connect } from 'react-redux'
import LogPointsAPIsBody, { ExternalProps, ValueProps, EventProps } from './LogPointsAPIsBody'
import * as actions from './actions'
import selectors from './selectors'

const mapStateToProps = (state: AppState, ownProps: ExternalProps): ValueProps => {
  return {
    ...ownProps,
    state: selectors.state(state),
    isLoadingLogPoints: selectors.isLoadingLogPoints(state),
    isSaving: selectors.isSaving(state),
    hasSavedYet: selectors.hasSavedYet(state),
    applicationFullDomain: selectors.applicationFullDomain(state),
    isRuntimeVerifiable: selectors.isRuntimeVerifiable(state),
    error: selectors.error(state),
  }
}

const mapDispatchToProps = (dispatch: Dispatch): EventProps => ({
  fetchLogPoints: (environmentId: string, resourceId: string) =>
    dispatch(actions.fetchLogPoints(environmentId, resourceId)),
  save: (props: ExternalProps, logPoints: LogPointStates) => {
    dispatch(actions.savingLogPointsAction())
    dispatch(actions.saveLogPoints(props, logPoints))
  },
  getApplicationFullDomain: (organizationId: string, environmentId: string, versionId: string) =>
    dispatch(actions.getApplicationFullDomain()(organizationId, environmentId, versionId)),
  getRuntimeVerifiable: (organizationId: string, environmentId: string, versionId: string) =>
    dispatch(actions.getRuntimeVerifiable(organizationId, environmentId, versionId)),
  resetError: () => dispatch(actions.resetError())
})

export default connect(mapStateToProps, mapDispatchToProps)(LogPointsAPIsBody)
